export default {"src":"/_next/static/media/revenue_icon.6bc6ebbc.svg","height":87,"width":95,"blurWidth":0,"blurHeight":0};